module.exports = __webpack_public_path__ + "img/iconBlue.9fe11ce2.png";